module.exports = __webpack_public_path__ + "static/reason_online-a12591175e8de2a33487fb59171971e3.png";